import { useMemo } from 'react';
import { useCurrentEnterpriseId } from '@mews-commander/core';
import { ReservationLinkResult, useRepositoryQuery } from '@mews-commander/data-access';
import { FeatureFlag } from '@mews-commander/enums';
import { isAccountIdCompany } from '@mews-commander/legacy-entities/src/selectors/bills';
import { useSortReservationForLinking } from '@mews-commander/legacy-entities/src/utils/useSortReservationForLinking';
import { useCommanderSelector } from '@mews-commander/utils';
import { useFeatureFlag } from '@mews/framework';

export const useGetReservationsForLinking = (
    accountId: string,
    scopedReservationIds?: string[]
): ReservationLinkResult[] => {
    const enterpriseId = useCurrentEnterpriseId();
    const isCompany = useCommanderSelector((state) => isAccountIdCompany(state, { accountId }));
    const newRoutingRulesPOSEnabled = useFeatureFlag(FeatureFlag.newRoutingRulesPOSEnabled);

    const { data } = useRepositoryQuery(
        'billing',
        'defaultReservationsForLinking',
        { enterpriseId, accountIds: [accountId], onlyUnpaidReservations: false },
        { enabled: newRoutingRulesPOSEnabled && !isCompany, refetchOnMount: 'always' }
    );

    const sortReservationForLinking = useSortReservationForLinking(scopedReservationIds);
    const reservations = useMemo(
        () => (data || []).toSorted(sortReservationForLinking),
        [data, sortReservationForLinking]
    );

    return reservations ?? [];
};
